var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.wrpCls },
    [
      _c("timezone-selector", { staticClass: "timezone-selector" }),
      _c("avatar-dropdown", {
        class: _vm.prefixCls,
        attrs: { menu: _vm.showMenu, "current-user": _vm.currentUser },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }